import { PlatformType } from "../helpers/subdomainHelpers/getPlatformType";

export type MarketplaceAction =
  | "select_offer_transfer_hub"
  | "select_offer_guest_platform"
  | "book_transport"
  | "book_gp_offer";

/** Stable traffic-source values for TransferHub reporting (wiki §6a). */
export type MarketplaceSource = "newsletter" | "mmb" | "direct" | "other";

/** Actions that should include the selected offer/event code in the payload. */
export const MARKETPLACE_ACTIONS_WITH_OFFER_CODE: readonly MarketplaceAction[] = [
  "select_offer_transfer_hub",
  "select_offer_guest_platform",
  "book_transport",
  "book_gp_offer"
];

/** Book / Buy milestone actions. */
export const MARKETPLACE_BOOK_ACTIONS: readonly MarketplaceAction[] = ["book_transport", "book_gp_offer"];

export type MarketplaceCurrentOffer = {
  offer_code: string | null;
  offer_type: string | null;
};

/** Session fields merged into the public dataLayer payload (wiki §6 / §6a). */
export type MarketplaceSessionEnrichment = {
  source?: MarketplaceSource | null;
  source_detail?: string | null;
  type?: string | null;
};

export type MarketplaceContextPayload = {
  event: "marketplace_context";
  marketplace_action: MarketplaceAction;
  platform: PlatformType;
  destination_airport: string | null;
  arrival_date: string | null;
  miles_and_more_provided: boolean;
  hotel_id: string | null;
  hotel_name: string | null;
  offer_code: string | null;
  type: string | null;
  source: MarketplaceSource | null;
  source_detail: string | null;
};

export type MarketplaceAirlineContextInput = {
  destinationAirport?: string | null;
  arrivalDate?: string | null;
  milesAndMoreNumber?: string | null;
};

export type PersistedAirlineRouterState = {
  meta?: { source?: string };
  shared?: {
    iataCode?: string | null;
    departureDate?: string | null;
    milesAndMore?: string | null;
  };
} | null;

export type MarketplaceHotelContextInput = {
  id?: string | null;
  name?: string | null;
};

export type BuildMarketplaceContextPayloadInput = {
  action: MarketplaceAction;
  platformType: PlatformType;
  airline?: MarketplaceAirlineContextInput;
  hotel?: MarketplaceHotelContextInput;
  offerCode?: string | null;
  persistedAirlineState?: PersistedAirlineRouterState;
  /** Optional session fields (tests or explicit overrides). When omitted, defaults are used. */
  session?: MarketplaceSessionEnrichment;
};

export type PushMarketplaceContextInput = BuildMarketplaceContextPayloadInput & {
  cookieAccepted?: boolean | null;
};
